/**
 * @description 改变url环境，如传入"www.duitang.com" ，当前环境在t000，则输出"www-t000.duitang.net"
 * @param {string} url 地址
 * @param {string} env 可选：在本地开发环境下，希望请求被改写到其他环境，环境需要手动指定，默认"-t000"
 * @returns currentEnvUrl
 */
const transformUrlToCurrentEnv = (url: string, env = '-t000'): string => {
  const currentHost = window.location.host;
  let _env = '';
  let type = '';
  if (/(-t\d+)\./.test(currentHost)) {
    _env = RegExp.$1;
    type = 'test';
  } else if (/dev\.duitang\.net/.test(currentHost)) {
    _env = env || '-t000';
    type = 'dev';
  } else if (/(-beta\d)\.duitang/.test(currentHost)) {
    _env = RegExp.$1;
    type = 'beta';
  } else {
    return url;
  }
  const splitList = url.split('.');
  splitList[0] += _env + '.';
  splitList[2] = (type === 'beta' ? '.com' : '.net') + splitList[2].replace(/^com|^net/, '');
  return splitList.join('');
};

export default transformUrlToCurrentEnv;
